export default __webpack_public_path__ + "assets/webgl/intro_0.d1baf292.png";